import BlockComponentValue from './BlockComponentValue';

class BlockComponentText implements BlockComponentValue {
  settings: any;
  value?: string;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockComponentText {
  export function make(text: string): BlockComponentText {
    return {
      settings: {},
      value: text,
    };
  }

  export function getDefault(): BlockComponentText {
    return make('テキスト');
  }
}

export default BlockComponentText;
